import { ArrowRight } from '@phosphor-icons/react'
import clsx from 'clsx'
import Link from 'next/link'
import { BardCallout as BardCalloutType } from '@/src/@types/statamic'
import Content from '@/src/components/elements/Content'

export default function BardCallout({
  optional_title: title,
  required_text: text,
  color,
  link_text,
  link_link,
}: BardCalloutType) {
  return (
    <div
      className={clsx('-mt-4 rounded-lg px-4 py-4 md:-mt-6 md:px-10 md:py-8', {
        'bg-purple-100': !color || color?.value === 'purple',
        'bg-yellow-100': color?.value === 'yellow',
        'bg-green-100': color?.value === 'green',
        'bg-red-100': color?.value === 'red',
      })}
    >
      {title && <p className="text-xl font-bold">{title}</p>}
      <Content content={text} className="mt-3" />
      {link_text && link_link?.url && (
        <Link
          href={link_link.url}
          className="group mt-5 flex items-center space-x-2 justify-self-start font-bold text-purple-600"
        >
          <span>{link_text}</span>
          <ArrowRight
            size={20}
            weight="bold"
            className="transition-transform group-hover:translate-x-1"
          />
        </Link>
      )}
    </div>
  )
}
